import React, {useEffect} from 'react';
import {DialogContent, Grid} from "@mui/material";
import {black400, black500, greyishBlue200} from "../../assets/jss/main";
import closeIcon from "../../assets/img/wms/close.svg";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";

Toast.propTypes = {
    icon: PropTypes.element.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    isTop: PropTypes.bool,
    bottomHeight: PropTypes.string,
    customTimeout: PropTypes.number
}

const margin = 16;

const paperRoot = {
    width: '100%',
    borderRadius: '8px',
    background: `${black500}`,
    border: `1px solid ${black400}`,
    color: 'white',
    margin: '0',
    boxShadow: '0px 4px 32px 0px rgba(34, 34, 34, 0.12), 0px 4px 32px 0px rgba(34, 34, 34, 0.12)',
    backgroundImage: 'linear-gradient(90deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 100%)',
}

const toastStyle = {
    width: `calc(100% - ${margin*2}px)`,
    height: 'fit-content',
    right: `${margin}px`,
    left: `${margin}px`,
    '& .MuiPaper-root ': paperRoot,
}

const toastTop = {
    top: '2%',
}

function Toast({
    icon,
    title,
    subtitle,
    open,
    handleClose,
    isTop = false,
    bottomHeight = '2%',
    isDesktop = false,
    customTimeout = 4000
}) {

    useEffect(() => {
        if (true === open) {
            setTimeout(() => {
                handleClose()
            }, customTimeout)
        }
    }, [open]);

    const finalToastStyle = {
        ...toastStyle,
        ...(isTop ? toastTop : {top: 'unset', bottom: bottomHeight}),
        ...(isDesktop && {'& .MuiDialog-container ': {justifyContent: 'end'}, '& .MuiPaper-root ': {...paperRoot, width: '25%'}}),
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disablePortal
            disableScrollLock
            disableAutoFocus
            disableEnforceFocus
            hideBackdrop
            sx={finalToastStyle}
        >
            <DialogContent sx={{padding: "8px 16px"}}>
                <Grid
                    container
                    alignItems={'center'}
                    justifyContent={'space-between'}
                >
                    <Grid
                        container
                        alignItems={'center'}
                        width={'fit-content'}
                        flexWrap={"nowrap"}
                    >
                        <Grid container sx={{
                            width: 'fit-content',
                            marginRight: '8px',
                        }}>
                            {icon}
                        </Grid>

                        <Grid
                            container
                            direction={'column'}
                            sx={{width: 'fit-content'}}
                        >
                            <span
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 600
                                }}
                            >
                                {title}
                            </span>
                            <span
                                style={{
                                    fontSize: '12px',
                                    fontWeight: 400,
                                    color: greyishBlue200
                                }}
                            >
                                {subtitle}
                            </span>
                        </Grid>
                    </Grid>

                    <Grid sx={{
                        width: 'fit-content',
                        position: 'absolute',
                        right: '4px',
                        top: '4px',
                    }}>
                        <img
                            style={{ cursor: 'pointer'}}
                            onClick={handleClose}
                            src={closeIcon}
                            alt={'close'}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default Toast;
